module.exports = __webpack_public_path__ + "static/media/Zoom-All.f242a514.svg";